import * as React from 'react'
import Loader from './Loader'
import { AuthContext } from '../../../context/authContext'

const silentRenew = () => {
  const { useContext, useEffect } = React
  const { authService } = useContext(AuthContext)
  useEffect(() => {
    authService.signinSilentCallback()
  }, [])
  return <Loader />
}

export default silentRenew
